import callWebApi from './callWebApi';

import {
  API_USER_URL,
  API_USER_EMPLOYMENT_URL,
  API_USER_DISCLOSURES_URL,
  API_USER_MEMBER_UPLOADS_URL,
  API_USER_ACCREDITATION_STATUS_URL,
  replacePlaceholders,
} from './urls';

import {
  createFetchActionCreator,
} from './index';


export const updateUser = updates => async (dispatch, getState) => {
  const { authToken, authTokenUser } = getState();
  dispatch({ type: 'USER_UPDATE/REQUESTED' });
  const url = replacePlaceholders(API_USER_URL, { userId: authTokenUser.id });
  await callWebApi('PATCH', url, updates, authToken);
  dispatch({ type: 'USER_UPDATE/SUCCEED' });
};


export const updateUserEmployment = employment => async (dispatch, getState) => {
  const { authToken, authTokenUser } = getState();
  dispatch({ type: 'USER_UPDATE_EMPLOYMENT/REQUESTED' });
  const url = replacePlaceholders(API_USER_EMPLOYMENT_URL, { userId: authTokenUser.id });
  await callWebApi('PUT', url, { employment }, authToken);
  dispatch({ type: 'USER_UPDATE_EMPLOYMENT/SUCCEED' });
};


export const updateUserDisclosures = disclosures => async (dispatch, getState) => {
  const { authToken, authTokenUser } = getState();
  dispatch({ type: 'USER_UPDATE_DISCLOSURES/REQUESTED' });
  const url = replacePlaceholders(API_USER_DISCLOSURES_URL, { userId: authTokenUser.id });
  await callWebApi('PUT', url, { disclosures }, authToken);
  dispatch({ type: 'USER_UPDATE_DISCLOSURES/SUCCEED' });
};

export const createUserUpload = (documentData, documentType, uploadType) =>
  async (dispatch, getState) => {
    const { authToken, authTokenUser } = getState();
    dispatch({ type: 'API_USER_MEMBER_UPLOADS_URL/REQUESTED' });
    const url = replacePlaceholders(API_USER_MEMBER_UPLOADS_URL, { userId: authTokenUser.id });
    await callWebApi('POST', url, {
      documentData,
      documentType,
      uploadType,
    }, authToken);
    dispatch({ type: 'API_USER_MEMBER_UPLOADS_URL/SUCCEED' });
  };

export const fetchUserAccreditationStatus = () => async (dispatch, getState) => {
  const { authTokenUser } = getState();
  const url = replacePlaceholders(API_USER_ACCREDITATION_STATUS_URL, { userId: authTokenUser.id });
  const fn = createFetchActionCreator(url, 'userAccreditationStatus', {}, { requireAuth: true })();
  return fn(dispatch, getState);
};



// WEBPACK FOOTER //
// ./src/actions/user.js